<script>
export default {
  data() {
    return {
      currentPage: 1,
      fields: ["item", "qty_returned", "qty_accepted"],
      items: [],
      type: "gravy",
    };
  },
  methods: {
    // Mirrors the return-invoice PDF format. Uses base units when present
    // (gravy = "X Pcs Y gm", packaging = "Z pcs"); falls back to the legacy
    // Pkts/Pcs text for older returns that have no base units stored.
    formatQty(item, confirmed) {
      const isGravy = item.gravy != null;
      const base = confirmed
        ? item.qty_base_units_confirmed
        : item.qty_base_units;
      const pkts = confirmed
        ? item.qty_returned_confirmed
        : item.qty_returned;
      const pcs = confirmed
        ? item.qty_returned_confirmed_pcs
        : item.qty_returned_pcs;
      if (base !== null && base !== undefined) {
        if (isGravy) {
          const uom = Math.max(1, Number(item.gravy.uom) || 1);
          const full = Math.floor(Number(base) / uom);
          const loose = Number(base) % uom;
          return `${full} Pcs${loose > 0 ? ` ${loose} gm` : ""}`;
        }
        return `${base} pcs`;
      }
      return `${pkts} Pkts${pcs > 0 ? ` ${pcs} Pcs` : ""}`;
    },
  },
  props: ["items_data", "status"],
  mounted() {
    console.log(this.items_data, "ee");
    this.items = this.items_data;
  },
};
</script>

<template>
  <b-card>
    <b-card-body>
      <b-tabs>
        <b-tab title="Gravy" @click="() => (type = 'gravy')"></b-tab>
        <b-tab title="Packaging" @click="() => (type = 'packaging')"></b-tab>
      </b-tabs>
      <b-table
        :key="2"
        responsive="sm"
        :items="
          items.filter((f) =>
            type == 'gravy' ? f.gravy != null : f.packaging != null
          )
        "
        :fields="fields"
        :current-page="currentPage"
        :per-page="10"
      >
        <template v-slot:cell(item)="row">
          <p>
            {{
              row.item.gravy != null
                ? row.item.gravy.name
                : row.item.packaging.name
            }}
          </p>
        </template>

        <template v-slot:cell(qty_returned)="row">
          <span>{{ formatQty(row.item, false) }}</span>
        </template>
        <template v-slot:cell(qty_accepted)="row">
          <div v-if="status == 'accepted' || status == 'completed'">
            <span>{{ formatQty(row.item, true) }}</span>
          </div>
        </template>
      </b-table>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                :key="1"
                v-model="currentPage"
                :total-rows="items.length"
                :per-page="10"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<style></style>
